import { isEmpty } from "lodash"
import { DEFAULT_MODE_SELECTOR_OPTIONS, END_VS_START_MODE_SELECTOR_OPTIONS } from "./index"
import type { SelectedTypedInstrument } from "helpers/types/instruments/selected"

export interface ModeSelectorOptionWithDisabledState {
  id: string
  primaryText: string
  group: number
  needComparison?: boolean
  needRebalanced?: boolean
  disabled: boolean
}

/**
 * Get mode selector options based on current instruments and comparison mode
 *
 * @param secondInstrument - The rebalanced instrument
 * @param comparisonInstrument - The comparison instrument
 * @param isEndVsStartDateComparison - Whether in end vs start comparison mode
 * @returns Mode selector options or null if no options available
 */
export function getModeSelectorOptions(
  secondInstrument: SelectedTypedInstrument | null | undefined,
  comparisonInstrument: SelectedTypedInstrument | null | undefined,
  isEndVsStartDateComparison: boolean,
): ModeSelectorOptionWithDisabledState[] | null {
  if (!isEndVsStartDateComparison && isEmpty(secondInstrument) && isEmpty(comparisonInstrument)) {
    return null
  }

  const options = isEndVsStartDateComparison ? END_VS_START_MODE_SELECTOR_OPTIONS : DEFAULT_MODE_SELECTOR_OPTIONS

  return options.map((option) => {
    let disabled = false
    if (option.needRebalanced && isEmpty(secondInstrument)) {
      disabled = true
    }
    if (option.needComparison && isEmpty(comparisonInstrument)) {
      disabled = true
    }

    return {
      ...option,
      disabled,
    }
  })
}
